<template>
	<v-card class="live-tile" v-bind="$attrs" :to="$attrs.to" @click="click">
		<header>
			<slot name="title">
				<v-card-title v-if="title">{{ title }}</v-card-title>
			</slot>
			<slot name="subtitle">
				<v-card-subtitle v-if="subtitle">{{ subtitle }}</v-card-subtitle>
			</slot>
		</header>

		<v-responsive v-if="aspectRatio" :aspect-ratio="aspectRatio">
			<slot />
		</v-responsive>
		<div v-else class="fill-height">
			<slot />
		</div>

		<v-card-actions v-if="defaultActions" class="actions">
			<slot name="actions">
				<v-spacer />
				<v-card-title v-if="actionTitle" class="actions--title">
					{{ actionTitle }}
				</v-card-title>
				<v-spacer />
				<v-btn icon>
					<v-icon>fa-expand</v-icon>
				</v-btn>
			</slot>
		</v-card-actions>
	</v-card>
</template>

<style lang="scss" scoped>
.live-tile {
	display: flex;
	flex-flow: column;
	height: 100%;

	> div {
		flex: 0 1 auto;
	}

	.fill-height {
		flex: 1 1 auto;
	}

	::v-deep > .v-responsive {
		flex-grow: 1;

		> .v-responsive__content {
			display: flex;
			flex-direction: column;
		}
	}

	::v-deep .flex-title {
		flex: 0 1 auto;
	}

	::v-deep .body {
		flex-grow: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 16px;

		i {
			font-size: 10em;
		}
	}

	.actions {
		display: flex;
		flex-flow: row;

		&--title {
			color: var(--v-pale-grey-darken4);
			font-size: 1em;
		}
	}

	&--nav {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;

		border: 2px solid var(--v-pale-grey-darken1);

		.body {
			display: flex;
			flex-direction: column;
			flex-grow: 2;
		}
	}
}
</style>

<script>
export default {
	props: {
		title: {
			type: String,
			required: false,
			default: null,
		},
		subtitle: {
			type: String,
			required: false,
			default: null,
		},
		actionTitle: {
			type: String,
			required: false,
			default: null,
		},
		defaultActions: {
			type: Boolean,
			required: false,
			default: true,
		},
		aspectRatio: {
			type: [String, Number],
			required: false,
			default: null,
		},
	},

	methods: {
		click(e) {
			const hasHandler = !!(this.$listeners && this.$listeners.click);
			if (hasHandler) {
				e.preventDefault();
				return this.$emit("click", e);
			}
		},
	},
};
</script>
